(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-shared/deposit-coverage-warning.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-shared/deposit-coverage-warning.js');

'use strict';

const _React = React,
  Fragment = _React.Fragment;
const Paper = svs.ui.ReactPaper;
const capitalizeString = svs.utils.format.capitalize;
const DepositCoverageWarning = () => {
  const instantPayInformation = ReactRedux.useSelector(state => state.deposit.instantPay);
  const content = () => {
    if ((instantPayInformation === null || instantPayInformation === void 0 ? void 0 : instantPayInformation.product) === 'spela-tillsammans') {
      return React.createElement("p", {
        className: "margin-bottom-0"
      }, "F\xF6r att kunna f\xF6ra \xF6ver till laget beh\xF6ver du s\xE4tta in minst", ' ', instantPayInformation === null || instantPayInformation === void 0 ? void 0 : instantPayInformation.diffFromBalance, ' ', "kr.");
    }
    return React.createElement(Fragment, null, React.createElement("p", {
      className: "margin-bottom-0 f-medium"
    }, "Ditt spel p\xE5", ' ', capitalizeString(instantPayInformation === null || instantPayInformation === void 0 ? void 0 : instantPayInformation.product, true), ' ', "kostar", ' ', instantPayInformation === null || instantPayInformation === void 0 ? void 0 : instantPayInformation.priceOfGame, ' ', "kr."), React.createElement("p", {
      className: "margin-bottom-0"
    }, "F\xF6r att kunna betala ditt spel beh\xF6ver du s\xE4tta in minst", ' ', instantPayInformation === null || instantPayInformation === void 0 ? void 0 : instantPayInformation.diffFromBalance, ' ', "kr."));
  };
  return React.createElement(Paper, {
    branding: "tur",
    className: "padding-v-1 padding-h-2 deposit-coverage-warning margin-top-1"
  }, content());
};
svs.accountservicesReact.deposit.depositShared.DepositCoverageWarning = DepositCoverageWarning;

 })(window);